import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import AlertLocationAddress from '@rsos/components/capstone/DataCards/DataCardLocation/LocationAddress';
import LocationTime from '@rsos/components/capstone/DataCards/DataCardLocation/LocationTime';
import { Box, Accordion } from '@rsos/components/capstone/base';
import EstimatedAddressLabel from './EstimatedAddressLabel';
import LatLong from './LatLong';
import Uncertainty from './Uncertainty';
import What3words from './What3words';
import {
  SingleWrapper,
  CircleAndLine,
  Circle,
  Line,
  InfoWrapper,
  SingleLocationWrapper,
} from './styles/singleHistoricLocation.styles';

const SingleHistoricLocation = memo(({ location }) => {
  const timeStamp = parseFloat(location.created_at);
  const { irpVersion } = useSelector(state => state.sinatra.irp);

  return (
    <SingleWrapper>
      <Accordion
        margin="0"
        headerPadding="0"
        btnSize="xsmall"
        btnPx="6px"
        noBorder
        header={
          <SingleLocationWrapper horizontal>
            <CircleAndLine>
              <Circle />
              <Line />
            </CircleAndLine>
            <InfoWrapper>
              <LocationTime
                {...{ timeStamp }}
                color="states"
                noDate
                size="small"
                timeAgoTextSize="small"
                timeBoxTextSize="xsmall"
              />
              <AlertLocationAddress isHistoricLocation civic={location.civic} />
            </InfoWrapper>
          </SingleLocationWrapper>
        }
        interactionType="button"
        height={180}
        width="100%"
        padding="0"
        justify="flex-start"
        content={
          <Box>
            <LatLong
              longitude={location.geodetic.longitude}
              latitude={location.geodetic.latitude}
              irpVersion={irpVersion}
            />
            <What3words isHistoricLocation location={location} />
            <Uncertainty
              uncertaintyRadius={location.geodetic.uncertainty_radius}
            />
          </Box>
        }
      ></Accordion>
      <EstimatedAddressLabel singleHistoricLocation />
    </SingleWrapper>
  );
});

export default SingleHistoricLocation;
